import { render } from "./Checkpoint.vue?vue&type=template&id=31cbf5cc&scoped=true"
import script from "./Checkpoint.vue?vue&type=script&lang=js"
export * from "./Checkpoint.vue?vue&type=script&lang=js"

import "@/assets/css/style.css?vue&type=style&index=0&id=31cbf5cc&scoped=true&lang=css"

import exportComponent from "D:\\archive\\my8\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31cbf5cc"]])

export default __exports__